import { ReactNode } from "react";
import { ThemeProvider } from "@mui/material/styles";

import AdminFonts from "./AdminFonts";
import { adminTheme } from "./adminTheme";
import { AdminFocusStyle } from "./focusOutline";

interface AdminThemeProviderProps {
  children: ReactNode;
}

const AdminThemeProvider = ({ children }: AdminThemeProviderProps) => (
  <ThemeProvider theme={adminTheme}>
    <AdminFonts />
    <AdminFocusStyle />
    {children}
  </ThemeProvider>
);

export default AdminThemeProvider;
